<template>
    <div>
        <div class="jd-block__title">
            <k-row>
                <k-col span="12">藏品信息</k-col>
                <k-col span="12" class="ta-right">
                    <slot name="right"></slot>
                </k-col>
            </k-row>
        </div>
        <k-cell-group>
            <k-cell>
                <span class="cl-desc">藏品描述：</span>{{des}}
            </k-cell>
            <k-cell>
                <template v-if="files">
                    <div v-for="(item, index) in files" :key="'video'+index" class="k-img-item">
                        <span class="k-index--num" v-if="num">{{index+1}}</span>
                        <k-icon name="play-circle" class="k-img-item--iconPlay" size="0.8rem" @click="openVideo(index)"></k-icon>
                        <img :src="getVideoImg(item)" alt="">
                    </div>
                </template>
                <template v-if="pictures">
                    <div v-for="(item, index) in pictures" :key="'pictures'+index" class="k-img-item">
                        <span class="k-index--num" v-if="num">{{index+1}}</span>
                        <img :src="item.content|resize(480,480)" @click="showImgView(index)" alt="">
                    </div>
                </template>
            </k-cell>
        </k-cell-group>
        <k-hr />

        <k-popup v-model="videoPopup" :overlay="true" class="popup-video">
            <div class="">
                <video
                    data-v-10088370=""
                    autoplay
                    :poster="poster"
                    oncontextmenu="return false"
                    controls="controls"
                    webkit-playsinline=""
                    playsinline=""
                    x5-playsinline=""
                    x-webkit-airplay="allow"
                    controlslist="nodownload noremoteplayback"
                    class="k-video"
                    :src="video"
                >
                </video>
            </div>
        </k-popup>
        <span v-if="videoPopup" class="popup-close--bottom" @click="videoPopup=false"><k-icon name="close-o" color="#ddd" size="40"></k-icon></span>
    </div>
</template>

<script>
    import { ImagePreview } from 'kvue';
    import {mapGetters} from "vuex"
    export default {
        name: "goods-info",
        props:["des", "files", "pictures", "num"],
        data(){
            return {
                videoPopup : false,
                video : '',
                poster : ''

            }
        },
        computed : {
          ...mapGetters("jianding", ["CONST"])
        },
        methods : {
            showImgView(index){
                let imgList = [];
                this.pictures.forEach((item) => {
                    imgList.push(item.content)
                });
                const instance = ImagePreview({
                    images: imgList,
                    startPosition: typeof index === "number" ? index : 0,
                    onClose: () => {

                    }
                });
            },
            openVideo(index){
                let video = this.files[typeof index === "number" ? index : 0];
                let img = video + '?x-oss-process=video/snapshot,t_2000,f_jpg,w_600,h_400';
                this.video = video;
                this.poster = img;
                this.videoPopup = true;
            },
            showVideo(index){
                let video = this.files[typeof index === "number" ? index : 0];
                let img = video + '?x-oss-process=video/snapshot,t_2000,f_jpg,w_600,h_400';
                let el = `<video data-v-10088370="" autoplay poster="${img}" oncontextmenu="return false" controls="controls" webkit-playsinline="" playsinline="" x5-playsinline="" x-webkit-airplay="allow" controlslist="nodownload noremoteplayback" class="k-video" src="${video}"></video>`
                this.$dialog.alert({
                    message: el
                }).then(() => {
                    // on close
                    document.querySelector('.k-video').pause()
                });
            },
            getVideoImg(video){
                if(video){
                    return video + '?x-oss-process=video/snapshot,t_2000,f_jpg,w_400,h_400'
                } else {
                    return this.CONST['VIDEO_DEFAULT_IMG'] || ''
                }
            }
        },
        watch : {
            videoPopup(nv){
                if(!nv) {
                    document.querySelector('.k-video').pause()
                }
            }
        }
    }
</script>

<style scoped>

</style>